"use client";
import { cva as e } from "class-variance-authority";
const r = e([
  "h-5 opacity-70 rounded-sm shadow-none",
  "bg-clip-padding cursor-default pointer-events-none",
  "before:invisible after:invisible *:invisible",
  "animate-skeleton-bg-fade select-none",
  "[--start-color:theme(colors.gray.50)]",
  "[--end-color:theme(colors.gray.300)]",
  "dark:[--start-color:theme(colors.gray-dark.800)]",
  "dark:[--end-color:theme(colors.gray-dark.600)]",
  "bg-[--start-color] border-[--end-color]"
]);
export {
  r as skeleton
};
